import Event from 'assets/eventinformation.svg';
import General from 'assets/general.svg';
import Holiday from 'assets/holiday.svg';
import Legal from 'assets/legal.svg';
import Study from 'assets/study.svg';

enum ArticleType {
  GENERAL = 'general',
  STUDY = 'study',
  EVENT = 'event',
  LEGAL = 'legal',
  HOLIDAY = 'holiday'
}

interface Props {
  articleType: string;
}

export default function ArticleTypeLogo({ articleType }: Props) {
  let logo;
  switch (articleType) {
    case ArticleType.GENERAL:
      logo = General;
      break;
    case ArticleType.STUDY:
      logo = Study;
      break;
    case ArticleType.EVENT:
      logo = Event;
      break;
    case ArticleType.LEGAL:
      logo = Legal;
      break;
    case ArticleType.HOLIDAY:
      logo = Holiday;
      break;
  }
  return <img src={logo} width={53} height={67} alt="no logo" />;
}
